import Backoffice from "@snark/backoffice"

// noinspection JSUnusedLocalSymbols
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
	function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	return new (P || (P = Promise))(function (resolve, reject) {
		function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
		function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
		function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
		step((generator = generator.apply(thisArg, _arguments || [])).next());
	});
};

const context = {
};

export default {
	name: "match",
	collection: "match",
	idProperty: "_id",
	section: "app",
	sort: {"back":[{"field":"date"}]},
	pagination: 50,
	backTextFilterList: true,
	labels: {"singleTitle":"Match","listTitle":"Matchs"},
	emptyItem: {},
	fields: [
		{
			name: "_id",
			label: "Id",
			readOnly: true,
			hideOnCreate: true,
		},
		{
			name: "hudlId",
			label: "Hudl Id",
		},
		{
			name: "date",
			label: "Date",
			formatter: Backoffice.formatters.date("DD/MM/YYYY"),
			editor: {type: "date"},
		},
		{
			name: "tournamentHudlId",
			label: "Tournament Hudl Id",
		},
		{
			name: "tournamentName",
			label: "Tournament Name",
		},
		{
			name: "seasonHudlId",
			label: "Season Hudl Id",
		},
		{
			name: "seasonName",
			label: "Season Name",
		},
		{
			name: "team1HudlId",
			label: "Team1Hudl Id",
		},
		{
			name: "team1Name",
			label: "Team1Name",
		},
		{
			name: "team2HudlId",
			label: "Team2Hudl Id",
		},
		{
			name: "team2Name",
			label: "Team2Name",
		},
		{
			name: "team1Score",
			label: "Team1Score",
		},
		{
			name: "team2Score",
			label: "Team2Score",
		},
		{
			name: "statusHuldId",
			label: "Status Huld Id",
		},
		{
			name: "statusName",
			label: "Status Name",
		},
		{
			name: "matchName",
			label: "Match Name",
		},
	],
	listColumns: [
	],
	loadSingle() {
		return Promise.all([
		]);
	},
};